<template>
  <b-container class="search"
               :class="{'empty': !hasResults && !hasAddress}">
    <section class="headline">
      <h2 class="display">Find food assistance anywhere</h2>
    </section>

    <section v-if="isPreloaded" class="search-section">
      <b-row align-v="center">
        <b-col cols="auto" class="flex-grow-1">
          <SearchAddress />
        </b-col>
        <b-col cols="auto" class="button-col">
          <SuperButton v-show="hasResults && !isSearching && isReadyToSearch &&  hasAddress"
                     variant="danger"
                     :click="showResults">
            <Icon :type="services.length == 0 ? 'remove' : 'arrow' "></Icon>
            <p>{{buttonLabel}}</p>
          </SuperButton>
        </b-col>
      </b-row>
    </section>
    <b-spinner v-else
               type="grow"></b-spinner>

    <section class="middle"
             v-if="hasAddress && isPreloaded">

      <b-spinner variant="primary"
                 class="ml-3"
                 type="grow"
                 v-if="isSearching"></b-spinner>



      <div class="no-results"
           v-if="!isSearching && !hasResults && hasAddress ">
        <h3 class="display">
          <b>No results found</b>
        </h3>
        <p>We could not find any services near this location that matches your criteria. For assistance finding resources call the Hunger Hotline at
          <b-link variant="outline-primary"
                  :href="'tel:'+hotline.en">{{hotline.en}}</b-link>
          /
          <b-link variant="outline-primary"
                  :href="'tel:'+hotline.es">{{hotline.es}}</b-link>
          or <a href="https://www.feedingamerica.org/find-your-local-foodbank">Find Your Local Food Bank</a>
        </p>
      </div>

    </section>
  </b-container>
</template>

<script>
import SearchAddress from "@/components/db/search/SearchAddress"
//import SearchOptions from "@/components/db/search/SearchOptions"
import breakpoints from "@/scripts/Breakpoints.js"

export default {
  name: "EmbedSearch",
  components: {
    SearchAddress,
    //SearchOptions
  },
  mixins: [ breakpoints ],
  computed: {
    buttonLabel() {
      let r = this.services.length
      if ( r == 1 ) {
        return `${r} result`
      } else if ( r == 0 ) {
        return 'No results found'
      } else {
        return `${r} results`
      }
    },
  },
  watch: {
    isPreloaded(newVal) {
      if (newVal) {
        this.$store.dispatch("initialize");
      }
    }
  },
  mounted() {
    if (this.isPreloaded) {
      this.$store.dispatch("initialize");
    }
  },
  methods: {
    showResults() {
      let query = new URLSearchParams( this.$router.history.current.query ).toString();
      let url;
      if ( this.isMobile ) {
        url = `${window.location.origin}/results?${query}`;
      } else {
        // Get the best match and construct the URL
        let best_match = this.services[0];
        if (best_match) {
          url = `${window.location.origin}/result/${best_match.id}?${query}`;
        } else {
          url = `${window.location.origin}/results?${query}`;
        }
      }
      window.open(url, '_blank');
    }
  }
};
</script>
<style scoped lang="scss">
.search {
    display: grid;
    align-items: start;
    align-content: start;
    padding-top: var(--pxxl);
    min-height: 70vh;

    > header,
    > section {
        transition: all 0.5s ease-in-out;
        margin: var(--pm) 0;
    }

    &.empty > header,
    &.empty > section {
        margin: var(--pxs) 0;
    }

    section.search-section {
        display: flex;
        align-items: center;
        
        .row {
            width: 100%;
            align-items: center;
        }
        
        .button-col {
            display: flex;
            align-items: center;
        }
    }

    section.middle {
        display: grid;
        align-content: center;
        align-items: center;
        justify-content: start;

        .no-results {
            display: grid;
            grid-gap: var(--p4);
            max-width: 32rem;

            a {
                white-space: pre;
            }
        }
    }

    .super-button {
      margin-top: 30px;
    }
}
</style>
